import React from 'react';

import { FlashIcon, DoneIcon } from 'components/icons';
import { Container, Title, Helper, Section } from './LastUpload.styles';
import { chartOrange, brandColors } from 'styles/colors';
import moment from 'moment';

export const LastUpload = ({ isUnpublished, timestamp }) => {
	const formattedDate = moment
		.utc(timestamp, moment.ISO_8601)
		.local()
		.format('MMMM D, YYYY. h:mm a');

	return (
		<Container>
			<Section>
				<Title>{!isUnpublished ? 'Live' : 'Unpublished'} Data</Title>
				<Helper>Data load: {formattedDate}</Helper>
			</Section>
			<Section>
				{isUnpublished ? (
					<FlashIcon fill={chartOrange} width="28px" height="28px" />
				) : (
					<DoneIcon fill={brandColors.green} width="28px" height="28px" />
				)}
			</Section>
		</Container>
	);
};
